module.exports = __webpack_public_path__ + "img/资质证书.d34d5c48.png";